/**
 * SHA-256 hash (client-side, via Web Crypto API)
 * Retorna hex lowercase ou undefined se a string for vazia/nula.
 */
export async function sha256(str: string | undefined | null): Promise<string | undefined> {
  if (!str) return undefined;
  const buf = new TextEncoder().encode(String(str));
  const hashBuffer = await crypto.subtle.digest("SHA-256", buf);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

// Normalizadores, retornam undefined quando o valor e vazio/nulo
export const normEmail = (e: string | undefined | null) =>
  e ? e.toLowerCase().trim() : undefined;

export const normPhone = (p: string | undefined | null) =>
  p ? p.replace(/\D/g, "") : undefined;

export const normName = (n: string | undefined | null) =>
  n ? n.toLowerCase().trim() : undefined;

export const normCity = (c: string | undefined | null) =>
  c ? c.toLowerCase().replace(/\s+/g, "") : undefined;

export const normState = (s: string | undefined | null) =>
  s ? s.toLowerCase().slice(0, 2) : undefined;

export const normZip = (z: string | undefined | null) =>
  z ? z.replace(/\D/g, "") : undefined;
